import DoAction from "./DoAction";

export default class DoSetObjectMatrix extends DoAction {
    constructor(object, info) {
        super();

        this.object = object;
        this.matBefore = info.matBefore;
        this.matAfter = info.matAfter;
    }
	redo() {
        this.setMatrix(this.matAfter);
	}
	undo() {
        this.setMatrix(this.matBefore);
    }
    setMatrix(matrix) {
        this.object.matrix.copy(matrix);
        matrix.decompose(this.object.position, this.object.quaternion, this.object.scale);
        // this.object.updateMatrix();
        viewer.renderOnDemand.set();
    }
}